import type { EntityState, EntityAdapter } from '@ngrx/entity';
import type { LibraryBlockEntityType } from './library-blocks.models';

import { on } from '@ngrx/store';
import { createImmerReducer } from 'ngrx-immer/store';
import { createEntityAdapter } from '@ngrx/entity';

import { prepareDataForStore, TempStatus } from './library-blocks.models';

import BlocksActions from '@web/store/page-structure/blocks/blocks.actions';
import * as LibraryBlocksActions from './library-blocks.actions';

export const LIBRARY_BLOCKS_FEATURE_KEY = 'libraryBlocks';

export interface LibraryBlocksState extends EntityState<LibraryBlockEntityType> {
    selectedId?: string | number; // which LibraryBlocks record has been selected
    loaded: boolean; // has the LibraryBlocks list been loaded
    error?: string | null; // last known error (if any)
}

export const libraryBlocksAdapter: EntityAdapter<LibraryBlockEntityType> = createEntityAdapter<LibraryBlockEntityType>({
    selectId: (entity) => entity.blockId,
});

export const initialLibraryBlocksState: LibraryBlocksState = libraryBlocksAdapter.getInitialState({
    // set initial required properties
    loaded: false,
});

export const libraryBlocksReducer = createImmerReducer<LibraryBlocksState>(
    initialLibraryBlocksState,
    on(LibraryBlocksActions.loadLibraryBlocksSuccess, (state, { libraryBlocks }) =>
        libraryBlocksAdapter.setAll(prepareDataForStore(libraryBlocks), { ...state, loaded: true })
    ),
    on(LibraryBlocksActions.loadLibraryBlocksFailure, (state, { error }) => ({ ...state, error })),
    on(LibraryBlocksActions.upsertLibraryBlock, (state, { libraryBlock }) =>
        libraryBlocksAdapter.upsertOne(libraryBlock, state)
    ),
    on(LibraryBlocksActions.markAsDeleted, (state, { blockId }) =>
        libraryBlocksAdapter.updateOne({ id: blockId, changes: { tempStatus: TempStatus.deleted } }, state)
    ),
    on(LibraryBlocksActions.removeLibraryBlock, (state, { blockId }) => libraryBlocksAdapter.removeOne(blockId, state)),
    on(BlocksActions.removeBlock, (state, { block }) => {
        const blockId = block.id;
        const entity = state.entities[blockId];
        if (entity && entity.tempStatus === TempStatus.new) {
            return libraryBlocksAdapter.removeOne(blockId, state);
        } else {
            return libraryBlocksAdapter.updateOne({ id: blockId, changes: { tempStatus: TempStatus.deleted } }, state);
        }
    })
);
